import {
  ActivityCategory,
  ActivityDifficulty,
  ActivitySortField,
  ActivitySortOrder,
  GetActivitiesQueryVariables,
} from "../../../../../../graphql/graphql";

export type ActivitiesQueryState = {
  page: number;
  pageSize: number;
  titleSearch: string;
  categories: ActivityCategory[];
  typeKeys: string[];
  difficulties: ActivityDifficulty[];
  sortField: ActivitySortField;
  sortDirection: ActivitySortOrder;
};

export const initialActivitiesQueryState = (): ActivitiesQueryState => ({
  page: 0,
  pageSize: 20,
  titleSearch: "",
  categories: [],
  typeKeys: [],
  difficulties: [],
  /** Matches server default: difficulty ascending on first load */
  sortField: ActivitySortField.Difficulty,
  sortDirection: ActivitySortOrder.Asc,
});

export const buildActivitiesVariables = (
  state: ActivitiesQueryState
): GetActivitiesQueryVariables => {
  return {
    skip: state.page * state.pageSize,
    take: state.pageSize,
    sort: {
      fieldName: state.sortField,
      direction: state.sortDirection,
    },
    filters: {
      titleSearch: state.titleSearch,
      categories: state.categories,
      difficulties: state.difficulties,
      typeKeys: state.typeKeys,
    },
  };
};

export type ActivitiesQueryAction =
  | { type: "SET_PAGE"; page: number }
  | { type: "SET_PAGE_SIZE"; pageSize: number }
  | { type: "SET_TITLE_SEARCH"; titleSearch: string }
  | { type: "SET_CATEGORIES"; categories: ActivityCategory[] }
  | { type: "SET_TYPE_KEYS"; typeKeys: string[] }
  | { type: "SET_DIFFICULTIES"; difficulties: ActivityDifficulty[] }
  | { type: "TOGGLE_SORT"; field: ActivitySortField }
  | { type: "CLEAR_FILTERS" };

export const activitiesQueryReducer = (
  state: ActivitiesQueryState,
  action: ActivitiesQueryAction
): ActivitiesQueryState => {
  switch (action.type) {
    case "SET_PAGE":
      return { ...state, page: action.page };
    case "SET_PAGE_SIZE":
      return { ...state, pageSize: action.pageSize, page: 0 };
    case "SET_TITLE_SEARCH":
      return { ...state, titleSearch: action.titleSearch, page: 0 };
    case "SET_CATEGORIES":
      return { ...state, categories: action.categories, page: 0 };
    case "SET_TYPE_KEYS":
      return { ...state, typeKeys: action.typeKeys, page: 0 };
    case "SET_DIFFICULTIES":
      return { ...state, difficulties: action.difficulties, page: 0 };
    case "TOGGLE_SORT": {
      return {
        ...state,
        sortField: action.field,
        sortDirection:
          state.sortField === action.field
            ? state.sortDirection === ActivitySortOrder.Asc
              ? ActivitySortOrder.Desc
              : ActivitySortOrder.Asc
            : ActivitySortOrder.Asc,
        page: 0,
      };
    }
    case "CLEAR_FILTERS":
      return {
        ...initialActivitiesQueryState(),
        pageSize: state.pageSize,
        sortField: state.sortField,
        sortDirection: state.sortDirection,
      };
    default:
      return state;
  }
};
